export const MY_SCHOOLS = 'MY_SCHOOLS'
export const MY_SCHOOLS_SETTINGS = 'MY_SCHOOLS_SETTINGS'
export const MY_SAVED_SCHOOLS = 'MY_SAVED_SCHOOLS'
export const SAVE_SCHOOL_BUTTON = 'SAVE_SCHOOL_BUTTON'
export const SCHOOL_BROWSER = 'SCHOOL_BROWSER'
export const SCHOOL_TRIGGER = 'SCHOOL_TRIGGER'



// WEBPACK FOOTER //
// ./react/school-master/app-keys.js